import axios from "axios";

export const getAdminPaymentBatches = async (brandUserId, params = {}) => {
    return axios
        .post("admin/user/automated-payments/batches/page", {
            brandUserId,
            ...params,
        })
        .then((response) => response.data.result)
        .catch((error) => {
            console.error("Failed to get automated payment batches");
            console.error(error);
        });
};
